import React from 'react';
import { Button, HTMLParser, Image } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { giftCardSuggestionBlockName } from '@gik/create';
import { Product } from '@gik/core/models/gik/Product';
import SvgIcon from '@gik/ui/SvgIcon';

export interface IGiftCardSuggestionProps {
  product: Product;
  showProductName?: boolean;
  onClickDismiss: () => void;
}

export default function GiftCardSuggestion({
  product,
  showProductName = false,
  onClickDismiss,
}: IGiftCardSuggestionProps) {
  const bem = bemBlock(giftCardSuggestionBlockName);

  return (
    <div className={bem()}>
      <Image className={bem('thumbnail')} src={product?.gridImage} />
      {showProductName && (
        <div className={bem('product-name')}>
          <HTMLParser rawHtml={product.name} />
        </div>
      )}

      <Button
        noFocusStyling
        className={bem('dismiss-button')}
        circle
        size="xs"
        variant="danger"
        onClick={onClickDismiss}
      >
        <SvgIcon name="XCircleOutline" set="hero-icons" />
      </Button>
    </div>
  );
}
